export const ConstantImport: {
  GitCommit: {
    Hash: string,
    Date: string,
    Message: string
  },
  BaseURL: string,
  AccessAPI: {
    TargetURL: string
  },
  AccommodationAPI: {
    TargetURL: string,
    Scope: string,
    Authority: string,
    ClientID: string,
    RedirectURI: string;
  },
  UserAPI: {
    Scope: string,
    TargetURL: string
  },
  KXLinkURL: string
} = {
  GitCommit: {
    Hash: import.meta.env.VITE_GIT_COMMIT_HASH,
    Date: import.meta.env.VITE_GIT_COMMIT_DATE,
    Message: import.meta.env.VITE_GIT_LAST_COMMIT_MESSAGE,
  },
  BaseURL: import.meta.env.VITE_BASE_URL,
  AccessAPI: {
    TargetURL: import.meta.env.VITE_BACKEND_ACCESS_URL,
  },
  AccommodationAPI: {
    TargetURL: import.meta.env.VITE_ACCOMMODATIONAPI_URL,
    Scope: import.meta.env.VITE_ACCOMMODATIONAPI_SCOPE,
    Authority: import.meta.env.VITE_ACCOMMODATIONAPI_AUTHORITY,
    ClientID: import.meta.env.VITE_ACCOMMODATIONAPI_CLIENTID,
    RedirectURI: import.meta.env.VITE_ACCOMMODATIONAPI_REDIRECTURI
  },
  UserAPI: {
    Scope: import.meta.env.VITE_BACKEND_USER_SCOPE,
    TargetURL: import.meta.env.VITE_BACKEND_USER_URL
  },
  KXLinkURL: import.meta.env.VITE_KXLINK_URL
};
